import React from "react";
import Button from "../../common/Button";

type SignInModalProps = {
  open: boolean;
  onClose: () => void;
  onGoogle: () => Promise<void> | void;
  onGitHub: () => Promise<void> | void;
};

const SignInModal: React.FC<SignInModalProps> = ({
  open,
  onClose,
  onGoogle,
  onGitHub,
}) => {
  if (!open) return null;

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-label="Sign in"
      onClick={onClose}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(0, 0, 0, 0.65)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 4000,
        padding: "1rem",
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          width: "100%",
          maxWidth: "420px",
          background: "#050607",
          border: "1px solid rgba(255,255,255,0.1)",
          borderRadius: "1rem",
          padding: "2rem 1.5rem",
          boxShadow: "0 30px 80px rgba(0,0,0,0.55)",
        }}
      >
        <div className="d-flex justify-content-between align-items-start mb-3">
          <div>
            <h4 className="mb-1" style={{ color: "#fff" }}>
              Sign in to continue
            </h4>
            <p
              className="mb-0"
              style={{ color: "#acb4c0", fontSize: "0.9rem" }}
            >
              Choose your preferred provider
            </p>
          </div>
          <button
            onClick={onClose}
            className="btn btn-outline-light btn-sm"
            style={{
              borderRadius: "50%",
              width: 32,
              height: 32,
              padding: 0,
            }}
            aria-label="Close sign in dialog"
          >
            ×
          </button>
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "0.75rem",
          }}
        >
          <Button
            text="Continue with Google"
            gradient="linear-gradient(135deg, #ea4335, #4285f4)"
            fullWidth
            onClick={onGoogle}
          />
          <button
            className="btn btn-outline-light w-100 d-flex align-items-center"
            style={{
              borderRadius: "2rem",
              fontFamily: '"JetBrains Mono", monospace',
              padding: "0.65rem 1rem",
              gap: "0.5rem",
            }}
            onClick={onGitHub}
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden
            >
              <path
                d="M12 0.5C5.73 0.5 0.75 5.48 0.75 11.75c0 4.94 3.19 9.13 7.61 10.61.56.1.76-.24.76-.54 0-.27-.01-1-.02-1.96-3.09.67-3.74-1.5-3.74-1.5-.5-1.27-1.22-1.61-1.22-1.61-.99-.68.08-.66.08-.66 1.09.08 1.66 1.12 1.66 1.12.97 1.66 2.55 1.18 3.17.9.1-.7.38-1.18.69-1.45-2.47-.28-5.07-1.24-5.07-5.52 0-1.22.43-2.21 1.12-2.99-.11-.28-.49-1.41.11-2.94 0 0 .92-.29 3.02 1.13a10.46 10.46 0 012.75-.37c.93 0 1.87.13 2.75.37 2.1-1.42 3.02-1.13 3.02-1.13.6 1.53.22 2.66.11 2.94.7.78 1.12 1.77 1.12 2.99 0 4.29-2.61 5.24-5.09 5.52.39.34.73 1.01.73 2.04 0 1.47-.01 2.66-.01 3.03 0 .3.2.64.77.53C19.06 20.88 22.25 16.7 22.25 11.75 22.25 5.48 17.27.5 11 0.5h1z"
                fill="currentColor"
              />
            </svg>
            <span style={{ marginLeft: 6 }}>Continue with GitHub</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default SignInModal;
